export default function demoModal() {
    const modal = document.querySelector('[data-demo-modal]');
    const openers = [...document.querySelectorAll('[data-demo-modal-open]')];
    const closeButton = modal?.querySelector('[data-demo-modal-close]');

    if (!modal || !openers.length || !closeButton) {
        return;
    }

    let lastFocusedElement;

    const close = () => {
        modal.hidden = true;
        document.body.classList.remove('gh-demo-modal-open');
        lastFocusedElement?.focus();
    };

    const open = (event) => {
        event.preventDefault();
        lastFocusedElement = event.currentTarget;
        modal.hidden = false;
        document.body.classList.add('gh-demo-modal-open');
        closeButton.focus();
    };

    openers.forEach((opener) => opener.addEventListener('click', open));
    closeButton.addEventListener('click', close);

    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            close();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (modal.hidden) {
            return;
        }

        if (event.key === 'Escape') {
            close();
        }
    });
}
